import type { Options as Html2CanvasOptions } from 'html2canvas-pro'
import { useEffect, useState } from 'react'
import { toast } from 'react-toastify'

import { loadHtml2Canvas } from 'utils/load-html2canvas'

export const useHyperCopy = (
  selectedElement: HTMLElement | null,
  setSelectedElement: (
    value:
      | ((prevState: HTMLDivElement | null) => HTMLDivElement | null)
      | HTMLDivElement
      | null,
  ) => void,
  html2canvasOptions?: Partial<Html2CanvasOptions>,
): { isCopying: boolean; lastCopied: HTMLElement | null | undefined } => {
  const [isCopying, setIsCopying] = useState(false)
  const [lastCopied, setLastCopied] = useState<HTMLElement | null | undefined>(
    undefined,
  )

  useEffect(() => {
    if (selectedElement) {
      const onCopy = async (): Promise<void> => {
        setIsCopying(true)
        setTimeout(async () => {
          if (selectedElement) {
            const html2canvas = await loadHtml2Canvas()
            const canvas = await html2canvas(selectedElement, {
              scale: 1.5,
              ...html2canvasOptions,
            })
            canvas.toBlob(function (blob) {
              if (!blob) return
              const item = new ClipboardItem({ 'image/png': blob })
              navigator.clipboard.write([item])
            })
            setIsCopying(false)
            setLastCopied(selectedElement)
            toast.info('Item copied to clipboard')
            setSelectedElement(null)
          }
        }, 10)
      }
      onCopy()
    }
  }, [selectedElement, setSelectedElement, html2canvasOptions])

  return { isCopying, lastCopied }
}
